// Dependencies
import React, { Component } from 'react';
import {isMobileOnly} from 'react-device-detect';

// Multi Lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './app-footer.scss';

// Assets
import Facebook from "../../assets/icons/facebook.svg";
import Linkedin from "../../assets/icons/linkedin.svg";
import Instagram from "../../assets/icons/instagram.svg";
import Youtube from "../../assets/icons/youtube.svg";

import AtIcon from "../../assets/icons/at-solid.svg";
import PhoneIcon from "../../assets/icons/phone-alt-solid.svg";
import HomeIcon from "../../assets/icons/home-solid.svg";
import ClockIcon from "../../assets/icons/clock-solid.svg";

// Utils
import { checkPublicPage } from '../../common/utils/page-utils';

class AppFooter extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {

    return (
		checkPublicPage(window.location.href) === false ?
			<footer style={{background: "#0073AA"}}>	
				<section style={{background: "#0073AA", position: "relative"}}>
					<div className="footer-svg-div" data-negative="false">
						<svg className='footer-svg' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2600 131.1" preserveAspectRatio="none">
							<path style={{fill:"#0073AA"}} d="M0 0L2600 0 2600 69.1 0 0z"></path>
							<path style={{opacity:0.5, fill:"#0073AA"}} d="M0 0L2600 0 2600 69.1 0 69.1z"></path>
							<path style={{opacity:0.25, fill:"#0073AA"}} d="M2600 0L0 0 0 130.1 2600 69.1z"></path>
						</svg>		
					</div>
				</section>
				<div className="grid">
					<div className="lg:col-1"></div>
					<div className="col-12 md:col-12 lg:col-3 mgt-20">
						<div className="grid">
							<div className="col-12 md:col-6 lg:col-12 t-align-left pl-40">
								<img width="150" height="52" src="https://portal-qa.ordemdosfisioterapeutas.pt/wp-content/uploads/2021/02/ordem-fisioterapeutas-logo-branco.png"  alt="" loading="lazy"/>											
							</div>
							<div className="col-12 md:col-6 lg:col-12 t-align-left mgt-30 pl-40">
								<a href="https://www.facebook.com/Ordem-dos-Fisioterapeutas-103511351578169/" target="_blank">
									<img style={{color: "#FFFFFF"}} width={"30px"} height={"30px"} src={Facebook} />			
								</a>
								<a className="mgl-30" href="https://www.linkedin.com/company/ordem-dos-fisioterapeutas/" target="_blank">
									<img style={{color: "#FFFFFF"}} width={"30px"} height={"30px"} src={Linkedin} />					
								</a>
								<a className="mgl-30" href="https://www.instagram.com/ordem_dos_fisioterapeutas/" target="_blank">
									<img style={{color: "#FFFFFF"}} width={"30px"} height={"30px"} src={Instagram} />					
								</a>
								<a className="mgl-30" href="https://www.youtube.com/channel/UCo9GW16IU8lAGyull3a52BQ" target="_blank">
									<img style={{color: "#FFFFFF"}} width={"30px"} height={"30px"} src={Youtube} />					
								</a>
							</div>
						</div>
					</div>	
					<div className="col-12 md:col-6 lg:col-3 t-align-left">
						<ul>
							<li className="mgb-25 hide">
								<span style={{color: "#FFFFFF", fontSize: "16px", fontWeight: "600", lineHeight: "2em"}} className='c-pointer'>{this.props.t("general.links")}</span>
							</li>
							<li className="mgb-15 hide">
								<a href="https://www.sns.gov.pt/institucional/ministerio-da-saude/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >Ministério da Saúde</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="https://www.ers.pt/pt/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >Entidade Reguladora da Saúde</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="https://www.igas.min-saude.pt/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >Inspeção-Geral das Atividades em Saúde</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="https://www.dgs.pt/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >Direção-Geral da Saúde</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="https://world.physio/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >World Physiotherapy/WCPT</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="https://www.erwcpt.eu/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >ER-WCPT</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="https://www.whpa.org/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >World Health Professions Alliance</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="https://www.eurheca.eu/en/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >EURHeca</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="http://www.apfisio.pt/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >APFISIO</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="https://www.sfp.pt/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >Sindicato dos Fisioterapeutas Portugueses</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="https://www.livroreclamacoes.pt/inicio" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >Livro de Reclamações</span>
								</a>
							</li>
							<li className="mgb-15 hide">
								<a href="https://ordemdosfisioterapeutas.pt/perguntas-frequentes/" target="_blank">					
									<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} >{this.props.t("general.faq")}</span>
								</a>
							</li>
						</ul>
					</div>
					<div className="col-12 md:col-6 lg:col-4 t-align-left">
						<ul>
							<li className="mgb-25 hide">
							<span style={{color: "#FFFFFF", fontSize: "16px", fontWeight: "600", lineHeight: "2em"}} className='c-pointer'>{this.props.t("general.contacts")}</span>
							</li>
							<li className="mgb-15 hide">
								<div className="grid">
									<div className="col-1" style={{display: "flex", alignItems: "center"}}>
										<span className="mgr-5">
											<img style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} width={"18.75px"} height={"15px"} src={HomeIcon} />					
										</span>
									</div>
									<div className="col-11">
										<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}}>LEAP Center - Espaço Amoreiras<br/><br/> Rua D. João V, n° 24 - 1.03 <br/><br/>1250-091 Lisboa</span>
									</div>
								</div>
							</li>
							<li className="mgb-15 hide">
								<div className="grid">
									<div className="col-1" style={{display: "flex", alignItems: "center"}}>
										<span className="mgr-5">
											<img style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} width={"18.75px"} height={"15px"} src={AtIcon} />						
										</span>
									</div>
									<div className="col-11" style={{display: "flex", alignItems: "initial", marginBottom: "5px"}}>
										<a href="mailto:%20geral@ordemdosfisioterapeutas.pt">						
											<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}}> geral@ordemdosfisioterapeutas.pt</span>
										</a>								
									</div>
								</div>
							</li>
							<li className="mgb-15 hide">
								<div className="grid">
									<div className="col-1" style={{display: "flex", alignItems: "center"}}>
										<span className="mgr-5">
											<img style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} width={"18.75px"} height={"15px"} src={PhoneIcon} />				
										</span>
									</div>
									<div className="col-11">
										<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}}><a href="tel:210415932"><span style={{color: "#FFFFFF"}} >210 415 932</span></a><br/><br/>{this.props.t("general.telephone")}</span>
									</div>
								</div>
							</li>
							<li className="mgb-10 hide">
								<div className="grid">
									<div className="col-1" style={{display: "flex", alignItems: "center"}}>
										<span className="mgr-5">
											<img style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}} width={"18.75px"} height={"15px"} src={ClockIcon} />					
										</span>
									</div>
									<div className="col-11" style={{display: "flex", alignItems: "initial", marginBottom: "5px"}}>
										<span style={{fontSize: "12px", fontWeight: 300, color: "#FFFFFF"}}>{this.props.t("general.schedule")}</span>							
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div className="lg:col-1"></div>
					<div className="lg:col-1"></div>
					<div className="col-12 md:col-12 lg:col-10">
						<hr style={{color: "#FFFFFF"}}/>
					</div>
					<div className="lg:col-1"></div>
					<div className="col-1 md:col-1 lg:col-1"></div>
					{
						isMobileOnly ?
							<div className="col-10 md:col-10 lg:col-5 t-align-left mgb-10">
								<span style={{color: "#FFFFFF"}}>© Ordem dos Fisioterapeutas. {this.props.t("general.rights")}</span>
							</div>
							:
							<div className="col-10 md:col-10 lg:col-5 t-align-left mgb-10">
								<span style={{color: "#FFFFFF"}}>© Ordem dos Fisioterapeutas. {this.props.t("general.rights")}</span>
							</div>
					}
					{
						isMobileOnly ?
							<>
								<div className="col-1 md:col-1 lg:col-1"></div>
								<div className="col-1 md:col-1 lg:col-1"></div>
							</>
							: null
					}
					{
						isMobileOnly ?
							<>
								<div className="col-10 md:col-10 lg:col-2 t-align-left mgb-10">
									<a target="_blank" href="https://ordemdosfisioterapeutas.pt/pt/avisos-legais/">					
										<span style={{color: "#FFFFFF"}}>{this.props.t("general.legal")}</span>
									</a>
								</div>
								<div className="col-10 md:col-10 lg:col-3 t-align-left mgb-10">
									<a target="_blank" href="https://ordemdosfisioterapeutas.pt/politica-de-privacidade/">					
										<span style={{color: "#FFFFFF"}}>{this.props.t("general.privacy-policy")}</span>
									</a>
								</div>
							</>
							:
							<div className="col-10 md:col-10 lg:col-5 t-align-right mgb-10">
								<a target="_blank" href="https://ordemdosfisioterapeutas.pt/pt/avisos-legais/">					
									<span style={{color: "#FFFFFF"}}>{this.props.t("general.legal")}</span>
								</a>
								<a target="_blank" href="https://ordemdosfisioterapeutas.pt/politica-de-privacidade/">					
									<span style={{marginLeft: "40px", color: "#FFFFFF"}}>{this.props.t("general.privacy-policy")}</span>
								</a>
							</div>
					}

					<div className="col-1 md:col-1 lg:col-1"></div>
				</div>
			</footer>
			: null
    );
  }
}

export default withTranslation(AppFooter);